<template>
  <div v-if="isDownloading">
    <ui-loading-circle v-if="isDownloading === true" :descText="'downloadingDot'" :applyBackground="true" />
    <content-box v-else width="430px" class="popup__error">
      <div class="invalid-param" v-if="isDownloading === 'error'">
        <i class="icon icon--alert-size50"></i>
        <p class="title">{{ $t('common.downloadFailed.title') }}</p>
        <p class="desc">{{ $t('common.downloadFailed.desc') }}</p>
        <ui-button @click="onDownloading(false)">{{ $t('common.confirm') }}</ui-button>
      </div>
      <div class="invalid-param" v-if="isDownloading === 'notSupport'">
        <i class="icon icon--alert-size50"></i>
        <p class="title">{{ $t('common.browserNotSupported.title') }}</p>
        <p class="desc">{{ $t('common.browserNotSupported.desc') }}</p>
        <ui-button @click="onDownloading(false)">{{ $t('common.confirm') }}</ui-button>
      </div>
    </content-box>
  </div>
</template>

<script>
import UiLoadingCircle from '@/components/ui/UiLoadingCircle'
import UiButton from '@/components/ui/UiButton'
import ContentBox from '@/components/ui/ContentBox'

export default {
  name: 'HeatmapDownloadError',
  components: {
    UiLoadingCircle,
    UiButton,
    ContentBox
  },
  props: [
    'isDownloading'
  ],
  methods: {
    onDownloading (value) {
      this.$emit('onDownloading', value)
    }
  }
}
</script>

<style lang="scss" scoped>
.popup__error {
  @include positionXYcenter;
  width: 430px;
  border-radius: 14px;
  box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
  padding: 50px 30px 25px;
  box-sizing: border-box;
  overflow: hidden;
  text-align: center;

  .title {
    margin-top: 15px;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    color: #444444;
  }

  .desc {
    margin-top: 15px;
    font-size: 14px;
    text-align: center;
    color: #2f2f2f;
  }

  .ui-btn {
    margin-top: 60px;
  }
}
</style>
